import { Outlet } from 'react-router';

import { useAuth } from '@barboxx/admin-utils';

import { Spinner } from '../misc/Spinner';

export const PersistLogin = () => {
    // get this from local storage
    const persist = true;
    const {
        //  authorizationCheck,

        initializing,
        // initialized,
    } = useAuth();

    // useEffect(() => {
    //     // let isMounted = true;

    //     const verifyRefreshToken = async () => {
    //         authorizationCheck();
    //     };

    //     if (!auth?.user) {
    //         verifyRefreshToken();
    //     }
    //     // else {
    //     //     initialized()
    //     // }

    //     return () => {
    //         // isMounted = false;
    //     };
    // }, [auth?.user, authorizationCheck, initialized]);

    return !persist ? <Outlet /> : initializing ? <Spinner /> : <Outlet />;
};
